<script>
import axios from 'axios'
import * as Helpers from '@/assets/js/helpers.js'

export default {
  name: 'callback',
  props: ['code', 'state'],
  mounted: function () {
    if (this.$TEST_MODE) console.log('entered callback')

    let go = true
    const cd = localStorage.getItem('vc_au_c_' + this.$wixInstanceId)
    if (cd !== null && cd === this.code) go = false
    if (typeof this.code === 'undefined') go = true

    if (go) {
      const instanceId = this.$wixInstanceId
      localStorage.setItem('vc_au_c_' + instanceId, this.code)
      const url = this.$dbapi + '/vcita_callback/' + instanceId

      axios
        .post(url, { code: this.code })
        .then(function (response) {
          const d = Helpers.parseJSON(response.data)

          if (d !== null) {
            d.client_data = Helpers.parseJSON(d.client_data)

            if (d.client_data !== null && d.client_data.sub !== undefined) {
              localStorage.setItem('vc_usr_data_' + instanceId, JSON.stringify(d.client_data))
              console.log('Authentication OK, closing window')
            } else {
              document.body.innerHTML = '<h1>Authentication failed: client data invalid</h1>'
            }

            localStorage.setItem('vc_login_complete_' + instanceId, true)
            window.close()
          } else {
            document.body.innerHTML = '<h1>Authentication failed: client data invalid</h1>'
          }
        })
        .catch(function (error) {
          console.log(error)
          document.body.innerHTML = '<h1>Authentication failed: client data invalid</h1>'
          localStorage.setItem('vc_login_complete_' + instanceId, true)
        })
    } else {
      Wix.Settings.closeWindow({ target: 'MODAL' }) // eslint-disable-line
    }
  }
}
</script>
